<template>
  <div>
    <v-skeleton-loader
      :loading="loading"
      type="article, list-item-two-line@2, actions"
    >
      <v-container class="pt-0">
        <v-row>
          <v-card-title
            class="headline"
            style="color: black"
            :class="$vuetify.breakpoint.xs ? 'pb-2' : ''"
          >
            {{ $t("showOverview") }}
          </v-card-title>
          <v-chip-group
            :value="1"
            mandatory
            active-class="primary--text"
            :class="$vuetify.breakpoint.xs ? '' : 'py-2'"
            style="margin-left: 8px"
          >
            <v-chip @click="generateChart('day')">{{
              $t("last24Hours")
            }}</v-chip>
            <v-chip @click="generateChart('week')">{{
              $t("last7Days")
            }}</v-chip>
            <v-chip @click="generateChart('month')">{{
              $t("last30Days")
            }}</v-chip>
            <v-chip @click="generateChart('year')">{{
              $t("last12Months")
            }}</v-chip>
          </v-chip-group>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-card
              elevation="24"
              style="position: relative; min-height: 250px"
            >
              <div style="position: absolute; top: 0px; padding: 16px">
                <v-icon color="#e5f45e" style="margin-bottom: 8px"
                  >mdi-checkbox-multiple-marked-outline</v-icon
                >
                <h2 v-if="ordersSeries[0].data.length !== 0">
                  {{
                    ordersSeries[0].data.reduce(
                      (r, a) => a.map((b, i) => (r[i] || 0) + b),
                      []
                    )[1]
                  }}
                </h2>
                <span>{{ $t("numberOfOrders") }}</span>
              </div>
              <div style="position: absolute; bottom: 0px; width: 100%">
                <apexchart
                  height="125"
                  type="area"
                  :options="ordersChartOptions"
                  :series="ordersSeries"
                ></apexchart>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              elevation="24"
              style="position: relative; min-height: 250px"
            >
              <div style="position: absolute; top: 0px; padding: 16px">
                <v-icon color="#bfec59" style="margin-bottom: 8px"
                  >mdi-checkbox-marked-outline</v-icon
                >
                <h2 v-if="ordersValueSeries[0].data.length !== 0">
                  {{
                    (
                      ordersValueSeries[0].data.reduce(
                        (r, a) => a.map((b, i) => (r[i] || 0) + b),
                        []
                      )[1] /
                        ordersValueSeries[0].data.filter((e) => e[1] !== 0)
                          .length || 0
                    ).toFixed(2)
                  }}
                  {{ currencySymbol }}
                </h2>
                <span>{{ $t("averageOrderValue") }}</span>
              </div>
              <div style="position: absolute; bottom: 0px; width: 100%">
                <apexchart
                  height="125"
                  type="area"
                  :options="ordersValueChartOptions"
                  :series="ordersValueSeries"
                ></apexchart>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              color="secondary"
              elevation="24"
              style="position: relative; min-height: 250px"
            >
              <div
                style="
                  position: absolute;
                  top: 0px;
                  padding: 16px;
                  color: white;
                "
              >
                <v-icon color="primary" style="margin-bottom: 8px"
                  >mdi-currency-usd-circle-outline</v-icon
                >
                <h2 v-if="creditsSeries[0].data.length !== 0">
                  {{
                    creditsSeries[0].data
                      .reduce((r, a) => a.map((b, i) => (r[i] || 0) + b), [])[1]
                      .toFixed(2)
                  }}
                  {{ currencySymbol }}
                </h2>
                <span color="white">{{ $t("consumedCredit") }}</span>
              </div>
              <div style="position: absolute; bottom: 0px; width: 100%">
                <apexchart
                  height="125"
                  type="area"
                  :options="creditChartOptions"
                  :series="creditsSeries"
                ></apexchart>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card
              elevation="24"
              style="position: relative; min-height: 350px"
            >
              <div style="position: absolute; top: 0px; padding: 16px">
                <v-icon color="#13e46d" style="margin-bottom: 8px"
                  >mdi-currency-usd-circle-outline</v-icon
                >
                <h2 v-if="revenueSeries[0].data.length !== 0">
                  {{
                    revenueSeries[0].data
                      .reduce((r, a) => a.map((b, i) => (r[i] || 0) + b), [])[1]
                      .toFixed(2)
                  }}
                  {{ currencySymbol }}
                </h2>
                <span>{{ $t("revenue") }}</span>
              </div>
              <div style="position: absolute; bottom: 0px; width: 100%">
                <apexchart
                  height="225"
                  type="area"
                  :options="revenueChartOptions"
                  :series="revenueSeries"
                ></apexchart>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-skeleton-loader>
    <div id="whatsapp"></div>
  </div>
</template>

<script>
import transactionService from "../services/transaction.service";
import chartService from "../services/chart.service";

export default {
  data() {
    return {
      loading: true,
      remainingRestaurantCredit: 0,
      orderFee: null,
      transactions: [],
      ordersSeries: [
        {
          name: this.$t("orders"),
          data: [],
        },
      ],
      ordersValueSeries: [
        {
          name: this.$t("averageOrderValue"),
          data: [],
        },
      ],
      creditsSeries: [
        {
          name: this.$t("consumedCredit"),
          data: [],
        },
      ],
      revenueSeries: [
        {
          name: this.$t("revenue"),
          data: [],
        },
      ],
      ordersChartOptions: {
        chart: {
          height: 125,
          type: "area",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          animations: {
            initialAnimation: {
              enabled: true,
            },
          },
        },
        colors: ["#e5f45e"],
        fill: {
          colors: ["#e5f45e"],
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.55,
            opacityTo: 0.4,
            stops: [5, 90, 100],
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          padding: {
            left: 0,
            right: 0,
          },
          show: false,
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          enabled: true,
          x: {
            show: false,
          },
          marker: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            show: true,
            offsetY: 0,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
      ordersValueChartOptions: {
        chart: {
          height: 125,
          type: "area",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          animations: {
            initialAnimation: {
              enabled: true,
            },
          },
        },
        colors: ["#bfec59"],
        fill: {
          colors: ["#bfec59"],
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.55,
            opacityTo: 0.4,
            stops: [5, 90, 100],
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          padding: {
            left: 0,
            right: 0,
          },
          show: false,
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          enabled: true,
          x: {
            show: false,
          },
          marker: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            show: true,
            offsetY: 0,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
      creditChartOptions: {
        chart: {
          height: 125,
          type: "area",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "round",
          width: 5,
        },
        colors: ["#0360ec"],
        fill: {
          colors: ["#0360ec"],
          type: "gradient",
          gradient: {
            shade: "dark",
            shadeIntensity: 0.75,
            opacityFrom: 0.55,
            opacityTo: 0.4,
            stops: [5, 90, 100],
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          padding: {
            left: 0,
            right: 0,
          },
          show: false,
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          enabled: true,
          x: {
            show: false,
          },
          marker: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            show: true,
            offsetY: 0,
            style: {
              colors: "#fff",
            },
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
          axisBorder: {
            show: false,
          },
        },
      },
      revenueChartOptions: {
        chart: {
          height: 225,
          type: "area",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          animations: {
            initialAnimation: {
              enabled: true,
            },
          },
        },
        colors: ["#13e46d"],
        fill: {
          colors: ["#13e46d"],
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.55,
            opacityTo: 0.4,
            stops: [5, 90, 100],
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          padding: {
            left: 0,
            right: 0,
          },
          show: false,
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          enabled: true,
          x: {
            show: false,
          },
          marker: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            show: true,
            offsetY: 0,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
    };
  },
  computed: {
    currencySymbol() {
      return localStorage.currencySymbol;
    },
  },
  created() {
    if (localStorage.access) {
      const access = JSON.parse(localStorage.access);
      if (access.length === 0) this.$router.push("/create");
    }

    this.fetchData();
  },
  mounted() {
    $("#whatsapp").venomButton({
      phone: "+421950466441",
      avatar:
        "https://cdn.jsdelivr.net/gh/sjasik/piknik.cc@latest/images/whatsapp/avatar.png",
      buttonImage:
        "https://cdn.jsdelivr.net/gh/sjasik/piknik.cc@latest/images/whatsapp/icon.svg",
      nameClient: "Piknik",
      headerTitle: this.$t("usuallyRepliesWithinTheHour"),
      chatMessage: this.$t("whatsappChatMessage"),
      placeholder: this.$t("yourMessage"),
      showPopup: true,
      position: "right",
      size: "64px",
      buttonColor: "#25D366",
    });
    setTimeout(() => {
      $("#whatsapp .venom-button-popup").addClass("active");
    }, 2500);
  },
  methods: {
    async fetchData() {
      const resp = await transactionService.getTransactions(
        localStorage.getItem("restaurantId")
      );
      this.transactions = resp.transactions;
      this.orderFee = resp.orderFee;
      this.remainingRestaurantCredit = resp.remainingRestaurantCredit;
      this.generateChart("week");
      this.loading = false;
    },
    async generateChart(timePeriod) {
      const ordersSeries = await chartService.generateChartData(
        this.transactions,
        timePeriod,
        "orders",
        this.orderFee
      );
      this.ordersSeries = [
        {
          name: this.$t("orders"),
          data: ordersSeries,
        },
      ];

      const ordersValueSeries = await chartService.generateChartData(
        this.transactions,
        timePeriod,
        "ordersValue",
        this.orderFee
      );
      this.ordersValueSeries = [
        {
          name: this.$t("averageOrderValue"),
          data: ordersValueSeries,
        },
      ];

      const creditsSeries = await chartService.generateChartData(
        this.transactions,
        timePeriod,
        "credits",
        this.orderFee
      );
      this.creditsSeries = [
        {
          name: this.$t("consumedCredit"),
          data: creditsSeries,
        },
      ];

      const revenueSeries = await chartService.generateChartData(
        this.transactions,
        timePeriod,
        "revenue",
        this.orderFee
      );
      this.revenueSeries = [
        {
          name: this.$t("revenue"),
          data: revenueSeries,
        },
      ];
    },
  },
};
</script>

<style>
.apexcharts-inner .apexcharts-graphical {
  transform: translate(0, -10);
}
</style>
